import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { FidelidadeService } from 'src/app/modules/_services/fidelidade.service';
import { NavigationService } from 'src/app/modules/_services/navigation.service';
import { AuthService } from '../../../_services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {
  constructor(
    private router: Router,
    private authService: AuthService,
    private navigationService: NavigationService,
    private fidelidadeService: FidelidadeService
  ) {
    this.redirect("");
  }

  private redirect(rota: string): void {
    var membro = this.authService.LocalStorage.obterMembro();

    if(membro != '' && membro != null && membro != undefined)
      if (membro.tipoStatus === 7 || membro.tipoStatus === 11)
        if(rota != '/meusdados')
          this.router.navigate(['/meusdados'])
  }

  private membro: any;


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const sessaoValida = this.authService.LocalStorage.usuarioValido();
    this.redirect(state.url);
    if (!sessaoValida) {
      this.router.navigate(['/'], { queryParams: { returnUrl: state.url } });
      return false;
    }

    const expirado =
      this.authService.LocalStorage.tokenEstaExpirado(sessaoValida);
    if (expirado) {
      if (!state.url.includes('/logout'))
        this.router.navigate(['/logout'], {
          queryParams: { returnUrl: state.url },
        });
      return true;
    }

    this.authService.LocalStorage.currentUserDadosValidados.subscribe(
      (dadosValidado) => {
        if (dadosValidado != null && !dadosValidado)
          if (state.url != '/validar-dados')
            this.navigationService.irParaPorLink('/validar-dados');
      }
    );

    let dadosValidados = this.authService.LocalStorage.obterDadosValidados();

    if (dadosValidados == 'false') {
      if (state.url != '/validar-dados')
        this.navigationService.irParaPorLink('/validar-dados');
    } else if (dadosValidados == 'true') {
      if (state.url == '/validar-dados')
        this.navigationService.irParaPorLink('/index');
    }

    return true;
  }
}
